import { ClickToTextDetailsProvider } from 'pages/clickToText/pages/viewClickToText/context'
import { ClickToTextDetails } from './ClickToTextDetails'

export const ViewClickToText = () => (
  <ClickToTextDetailsProvider>
    <ClickToTextDetails />
  </ClickToTextDetailsProvider>
)
